import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Router , ResolveStart,RoutesRecognized,  NavigationStart, NavigationEnd, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StructureComponent } from './structure.component';
import { PagesModule } from './../pages/pages.module';
import { DashboardsModule } from './dashboards/dashboards.module';
import { DailyReportModule } from './dailyreport/dailyreport.module';
import { SubscriptionReportModule } from './subscriptionreport/subscriptionreport.module';
import { FaqModule } from './faq/faq.module';
import { CountryModule } from './country/country.module';
import { CountryGroupModule } from './countrygroup/countrygroup.module';
import { RegisterModule } from './register/register.module';
import { FillingStationAreaModule } from './fillingstationarea/fillingstationarea.module';
import { FillingStationModule } from './fillingstation/fillingstation.module';
import { FillingStationDeletedModule } from './fillingstationdeleted/fillingstationdeleted.module';
import { FillingStationIssueModule } from './fillingstationissue/fillingstationissue.module';
import { ApplicationModule } from './application/application.module';
import { ContactUsModule } from './contactus/contactus.module';
import { NotificationModule } from './notification/notification.module';
import { UserModule } from './user/user.module';
import { UserDeletedModule } from './userdeleted/userdeleted.module';
import { UserLogModule } from './userlog/userlog.module';
import { ChatModule } from './chat/chat.module';
import { BloguserModule } from './bloguser/bloguser.module';
import { BlogpostModule } from './blogpost/blogpost.module';
import { BlogUserdetailsModule } from './bloguserdetails/bloguserdetails.module';
import { BlogpostdetailModule } from './blogpostdetail/blogpostdetail.module';
import { BlogverifyModule } from './blogverify/blogverify.module';
import { BlogcategoryModule } from './blogcategory/blogcategory.module';
import { PortfolioModule } from './portfolio/portfolio.module';
import { FeedbackModule } from './feedback/feedback.module';
import { AdminCrashreportModule } from './admincrashreport/admincrashreport.module';
import { MobileCrashreportModule } from './mobilecrashreport/mobilecrashreport.module';
import { BackupdbModule } from './backupDB/backupDB.module';
declare var NProgress: any;
@NgModule({
  declarations: [
    StructureComponent
  ],
  imports: [
    BrowserModule, FormsModule, HttpModule, RouterModule, CommonModule, RouterModule,
    PagesModule,
    DashboardsModule, DailyReportModule, SubscriptionReportModule, FaqModule, CountryModule, CountryGroupModule, RegisterModule, ApplicationModule, NotificationModule, FeedbackModule,
    ContactUsModule, UserModule,UserDeletedModule,
    NgbModule.forRoot(),
    BloguserModule,
    BlogpostModule,
    BlogUserdetailsModule,
    BlogpostdetailModule,
    BlogverifyModule,
    BlogcategoryModule,
    PortfolioModule,
    FillingStationModule,
    FillingStationDeletedModule,
    FillingStationAreaModule,
    FillingStationIssueModule,
    UserLogModule,
    AdminCrashreportModule,
    MobileCrashreportModule,
    BackupdbModule,
    ChatModule
  ],
  providers: [],
  bootstrap: [StructureComponent]
})
export class StructureModule {
  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) 
      {
        NProgress.start();
      }
      if (event instanceof NavigationEnd) 
      {
        setTimeout(function () {
          NProgress.done();
        }, 200);
      }
    });
  }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/structure.module.ts